import '../css/app.css';
import * as Sentry from "@sentry/react";

import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';
import { initializeTheme } from './hooks/use-appearance';
import '@fontsource/instrument-sans/400.css';
import '@fontsource/instrument-sans/600.css';

const appName = import.meta.env.VITE_APP_NAME || '';

const sentryDNS = import.meta.env.VITE_SENTRY_DNS;

if (sentryDNS) {
    Sentry.init({
        dsn: sentryDNS,
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true
    });
}
const originalConsoleError = console.error;

console.error = function (...args) {
    // Call the original console.error
    originalConsoleError(...args);

    // Capture to Sentry with structured data
    const message = args.map(arg => {
        if (arg instanceof Error) return arg.stack || arg.message;
        return typeof arg === 'object' ? JSON.stringify(arg, null, 2) : String(arg);
    }).join(' ');

    Sentry.captureMessage(message, {
        level: 'error',
        extra: {
            originalArgs: args,
        },
    });

    // Dispatch custom event (optional but useful for debugging tools)
    try {
        const event = new CustomEvent('consoleError', {
            detail: { args },
        });
        window.dispatchEvent(event);
    } catch (e) {
        originalConsoleError('Failed to dispatch custom consoleError event:', e);
    }
};

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./pages/${name}.tsx`, import.meta.glob('./pages/**/*.tsx')),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(<App {...props} />);
    },
    progress: {
        color: '#4B5563',
    },
});

// This will set light / dark mode on load...
initializeTheme();
